/**
 * Texte d'une convocation, prêt à coller dans le groupe WhatsApp de l'équipe.
 * Le gras de WhatsApp s'écrit *ainsi*. Pour un match : les prénoms des présents
 * et de ceux qui n'ont pas encore répondu ; pour un entraînement : les nombres.
 */
const jourFr = iso => {
  try { return new Date(iso + 'T12:00:00Z').toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' }); }
  catch { return iso; }
};
const prenoms = l => l.map(p => p.prenom).filter(Boolean).join(', ');

export function texteConvocation(type, ev, { equipe, lien } = {}) {
  const convoques = (ev.presences || []).filter(p => p.convoque !== 0);
  const presents = convoques.filter(p => p.present);
  const attente = convoques.filter(p => !p.repondu && !p.excuse);
  const absents = convoques.filter(p => (p.repondu && !p.present) || (p.excuse && !p.present));
  const l = [];
  if (type === 'rencontre') {
    l.push(`🤾 *${equipe || 'Équipe'}* — convocation`);
    l.push(`⚽ *vs ${ev.adversaire}*${ev.dom_ext ? ` (${ev.dom_ext})` : ''}`);
    l.push(`📅 ${jourFr(ev.date)}`);
    const heures = [ev.heure_rdv && `Rendez-vous ${ev.heure_rdv}`, ev.heure && `coup d'envoi ${ev.heure}`].filter(Boolean).join(' · ');
    if (heures) l.push(`⏰ ${heures.charAt(0).toUpperCase()}${heures.slice(1)}`);
    if (ev.lieu) l.push(`📍 ${ev.lieu}`);
    l.push('');
    if (presents.length) l.push(`✅ Présents (${presents.length}) : ${prenoms(presents)}`);
    if (attente.length) l.push(`⏳ Sans réponse (${attente.length}) : ${prenoms(attente)}`);
    if (absents.length) l.push(`❌ Absents : ${absents.length}`);
  } else {
    l.push(`🤾 *${equipe || 'Équipe'}* — entraînement`);
    l.push(`📅 ${jourFr(ev.date)}${ev.heure ? ` · ${ev.heure}` : ''}`);
    if (ev.lieu) l.push(`📍 ${ev.lieu}`);
    if (ev.theme) l.push(`🎯 ${ev.theme}`);
    l.push('');
    l.push(`✅ Présents : ${presents.length} · ⏳ Sans réponse : ${attente.length}${absents.length ? ` · ❌ Absents : ${absents.length}` : ''}`);
  }
  if (lien) { l.push(''); l.push(`👉 Réponds dans Équipote : ${lien}`); }
  return l.join('\n');
}
